import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PaswordDialogComponent } from '@app/@shared/dialogs/password/password-dialog.component';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { CalculatorAutosDTO, CalculatorResponseDTO, Participant, RequestFormDTO } from '../model/requests-model';
import {
  CONTACT_DATA,
  DIRECT_DEBIT,
  FINANCE,
  FORM_AUTO,
  HOLDER_DATA,
  POINT_OF_SALE,
  REQUEST_DATA,
  REQUEST_OBSERVATIONS,
  SOCIOECONOMIC_DATA,
  REQUEST_MODE_NEW,
  APROBADAS,
  INTERVINIENTE_1_HOLDER_DATA,
  INTERVINIENTE_1_CONTACT_DATA,
  INTERVINIENTE_1_SOCIOECONOMIC_DATA,
  INTERVINIENTE_1_DIRECT_DEBIT,
  INTERVINIENTE_2_HOLDER_DATA,
  INTERVINIENTE_2_CONTACT_DATA,
  INTERVINIENTE_2_SOCIOECONOMIC_DATA,
  INTERVINIENTE_2_DIRECT_DEBIT,
  INTERVINIENTE_3_HOLDER_DATA,
  INTERVINIENTE_3_CONTACT_DATA,
  INTERVINIENTE_3_SOCIOECONOMIC_DATA,
  INTERVINIENTE_3_DIRECT_DEBIT,
  INTERVINIENTE_4_HOLDER_DATA,
  INTERVINIENTE_4_CONTACT_DATA,
  INTERVINIENTE_4_SOCIOECONOMIC_DATA,
  INTERVINIENTE_4_DIRECT_DEBIT,
  PRESCRIBER_CONTACT_DATA,
  REQUEST_STEPPER_1,
  REQUEST_STEPPER_2,
  REQUEST_STEPPER_3,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
  PENDIENTES_DE_DATOS,
} from '@app/@core/constants/requests.constants';
import { RequestsSaveSendStore } from '../requests-save-send-service/requests-save-send.store';
import { CombosStore } from '../combos-service/combos.store';
import { PrintStore } from '@app/@shared/services/print/print.store';
import { FormGroup } from '@angular/forms';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { CommonDataDTO, VendorComboDTO } from '../model/combos-model';
import { MatStepper } from '@angular/material/stepper';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-request-auto',
  templateUrl: './request-auto.component.html',
  styleUrls: ['./request-auto.component.scss'],
  providers: [],
})
export class RequestAutoComponent implements OnInit, OnDestroy, AfterContentChecked {
  @Input() mode: string = 'new';
  @Input() operative: string;
  @Input() state: CommonDataDTO;
  @Input() request: any = null;
  @Input() hostStatus: string = '';
  @Output() public isFinishedLoading = new EventEmitter<boolean>();
  @ViewChild('stepper') stepper: MatStepper;

  public establishment: string;
  public vendor: CommonDataDTO;
  public intervinientes: Participant[] = [];
  public selectedProductLine: string = null;
  public requestedAmount: string = null;
  public priceProduct: string = null;
  public start: string = null;
  public enviarPeticion: boolean;
  public tariffs: CalculatorResponseDTO;
  public dataFinance: CalculatorAutosDTO;

  public expirationMonth: string;
  public isFirstStepCompleted: boolean;
  public isSecondStepCompleted: boolean;
  public isThirdStepCompleted: boolean;
  public isEditAutos: boolean;

  public numOperation: string = '';
  public PENDIENTES_DE_DATOS = PENDIENTES_DE_DATOS;

  public disabledOwnership: any;
  public clearTable: boolean = false;

  changingValueClearTable: Subject<boolean> = new Subject();

  firstStepError: boolean = false;
  secondStepError: boolean = false;
  thirdStepError: boolean = false;

  maxParticipants = 3;
  newParticipants: number[] = [];

  //Loading
  private isPointOfSaleLoaded: boolean = false;
  private isRequestDataLoaded: boolean = false;
  private isFinanceLoaded: boolean = false;
  private isBasicContactLoaded: boolean = false;
  private isHolderLoaded: boolean = false;
  private isContactLoaded: boolean = false;
  private isSocioeconomicLoaded: boolean = false;
  private isDirectDebitLoaded: boolean = false;
  private isObservationsLoaded: boolean = false;
  private isPrescriberDataLoaded: boolean = false;

  constructor(
    private requestsStore: RequestsSaveSendStore,
    public dialog: MatDialog,
    private cdref: ChangeDetectorRef,
    private translate: TranslateService,
    private combosStore: CombosStore,
    private printStore: PrintStore,
    private customValidatorsService: CustomValidatorsService,
    private loaderGenericService: LoaderGenericService
  ) {}

  ngAfterContentChecked() {
    this.cdref.detectChanges();
    if (localStorage.getItem('addParticipantTab') === 'true') {
      this.stepper.selectedIndex = 1;
      localStorage.removeItem('addParticipantTab');
    }
  }

  public ngOnInit() {
    this.requestsStore.enviarPeticion$.subscribe((valor: boolean) => {
      this.enviarPeticion = valor;
    });

    this.requestsStore.firstStepSource$.subscribe((valor: boolean) => {
      this.isFirstStepCompleted = valor;
      this.changeErrorStateEditView(REQUEST_STEPPER_1);
    });

    this.requestsStore.secondStepSource$.subscribe((valor: boolean) => {
      this.isSecondStepCompleted = valor;
      this.changeErrorStateEditView(REQUEST_STEPPER_2);
    });

    this.requestsStore.thirdStepSource$.subscribe((valor: boolean) => {
      this.isThirdStepCompleted = valor;
      this.changeErrorStateEditView(REQUEST_STEPPER_3);
    });

    this.requestsStore.setMarcaFormulario(FORM_AUTO);
    this.combosStore.setLanguageRequest('ES');

    const listParticipants = Array.from({ length: this.maxParticipants }, (_, i) => i + 1);

    if (this.mode === REQUEST_MODE_EDIT) {
      this.isEditAutos = true;
    }

    if (this.mode !== REQUEST_MODE_NEW) {
      if (this.state.id === APROBADAS && (this.request.numRack === '' || this.request.carRegistration === '')) {
        this.isEditAutos = true;
      }
      this.numOperation = this.request.numOperation;
      listParticipants.splice(0, this.request.participants.length);
      this.newParticipants.push(...listParticipants);
      if (this.request.participants.length > 0) {
        this.request.participants.forEach((participantForm: any, index: number) => {
          console.log(index);
          if (this.mode === REQUEST_MODE_VIEW || (this.mode == REQUEST_MODE_EDIT && index < 3)) {
            const combination = {
              ...participantForm,
              fieldsDisable: this.request.fieldsDisable != null ? [...this.request.fieldsDisable] : [],
            };
            this.intervinientes.push({ id: index + 1, request: combination });
          }
        });
      }
    }
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    console.log('Method: On Destroy - Autos');
    this.requestsStore.setCheckContactData(false);
    this.requestsStore.setContactDataForm(null);
    this.requestsStore.listaFormulariosAutos = [];
    this.requestsStore.setFinanceAmountData(null);
    this.requestsStore.setVideoSelfingID('');
    this.clearTest();
  }

  public changeContinueStatusForms(formAuto: any) {
    if (formAuto) {
      this.requestsStore.listaFormulariosAutos[formAuto.id] = formAuto.form;
    }
    this.updateDisabledSendButton();
    this.updateSteps();
  }

  public disabledOwnershipCombo(value: any) {
    this.disabledOwnership = value;
  }

  public updateCombos(establishment: string) {
    this.establishment = establishment;
  }

  public updateDisabledSendButton() {
    if (this.requestsStore.listaFormulariosAutos.length >= 8) {
      //TODO: En la próxima minor release a la 13.0.2. de la líbreria Angular, la property Status pasará de ser String a FormControlStatus
      //Change - https://github.com/angular/angular/pull/42952
      //Issue - https://github.com/angular/angular/issues/44176

      const isInvalid = this.requestsStore.listaFormulariosAutos.findIndex((form) => form?.status === 'INVALID');
      if (isInvalid >= 0) {
        this.requestsStore.setEnviarPeticion(false);
      } else {
        this.requestsStore.setEnviarPeticion(true);
      }
    }
  }

  public updateSteps(): void {
    const firstStepForms = [POINT_OF_SALE, PRESCRIBER_CONTACT_DATA, REQUEST_DATA, FINANCE];
    const secondStepForms = [HOLDER_DATA, CONTACT_DATA, SOCIOECONOMIC_DATA];
    const thirdStepForms = [DIRECT_DEBIT, REQUEST_OBSERVATIONS];

    this.requestsStore.setFirstStep(this.updateStepsControl(firstStepForms));

    this.requestsStore.setSecondStep(
      this.updateStepsControl(secondStepForms)
        ? this.intervinientes.length === 0
          ? true
          : this.isIntervinientesSecondStepValid()
        : false
    );

    this.requestsStore.setThirdStep(
      this.updateStepsControl(thirdStepForms)
        ? this.intervinientes.length === 0
          ? true
          : this.isintervinientesThirdStepValid()
        : false
    );
  }

  public updateStepsControl(formIndex: number[]): boolean {
    let forms: FormGroup[] = [];
    for (let index of formIndex) {
      forms.push(this.requestsStore.listaFormulariosAutos[index]);
    }
    return forms.findIndex((form) => form?.status === 'INVALID') < 0;
  }

  public isIntervinientesSecondStepValid(): boolean {
    let secondStepForms;
    if (this.intervinientes.length === 1)
      secondStepForms = [INTERVINIENTE_1_HOLDER_DATA, INTERVINIENTE_1_CONTACT_DATA, INTERVINIENTE_1_SOCIOECONOMIC_DATA];

    if (this.intervinientes.length === 2)
      secondStepForms = [
        INTERVINIENTE_1_HOLDER_DATA,
        INTERVINIENTE_1_CONTACT_DATA,
        INTERVINIENTE_1_SOCIOECONOMIC_DATA,
        INTERVINIENTE_2_HOLDER_DATA,
        INTERVINIENTE_2_CONTACT_DATA,
        INTERVINIENTE_2_SOCIOECONOMIC_DATA,
      ];

    if (this.intervinientes.length === 3)
      secondStepForms = [
        INTERVINIENTE_1_HOLDER_DATA,
        INTERVINIENTE_1_CONTACT_DATA,
        INTERVINIENTE_1_SOCIOECONOMIC_DATA,
        INTERVINIENTE_2_HOLDER_DATA,
        INTERVINIENTE_2_CONTACT_DATA,
        INTERVINIENTE_2_SOCIOECONOMIC_DATA,
        INTERVINIENTE_3_HOLDER_DATA,
        INTERVINIENTE_3_CONTACT_DATA,
        INTERVINIENTE_3_SOCIOECONOMIC_DATA,
      ];

    if (this.intervinientes.length === 4)
      secondStepForms = [
        INTERVINIENTE_1_HOLDER_DATA,
        INTERVINIENTE_1_CONTACT_DATA,
        INTERVINIENTE_1_SOCIOECONOMIC_DATA,
        INTERVINIENTE_2_HOLDER_DATA,
        INTERVINIENTE_2_CONTACT_DATA,
        INTERVINIENTE_2_SOCIOECONOMIC_DATA,
        INTERVINIENTE_3_HOLDER_DATA,
        INTERVINIENTE_3_CONTACT_DATA,
        INTERVINIENTE_3_SOCIOECONOMIC_DATA,
        INTERVINIENTE_4_HOLDER_DATA,
        INTERVINIENTE_4_CONTACT_DATA,
        INTERVINIENTE_4_SOCIOECONOMIC_DATA,
      ];

    let forms: FormGroup[] = [];
    for (let index of secondStepForms) {
      forms.push(this.requestsStore.listaFormulariosAutos[index]);
    }

    return forms.findIndex((form) => form?.status === 'INVALID') >= 0 ? false : true;
  }

  private isintervinientesThirdStepValid(): boolean {
    let formsValid: FormGroup[] = [];
    const formsStored = [...this.requestsStore.listaFormulariosAutos];

    if (this.intervinientes.length === 1) {
      return !(formsStored[INTERVINIENTE_1_DIRECT_DEBIT]?.status === 'INVALID');
    } else {
      if (this.intervinientes.length === 2) {
        formsValid.push(formsStored[INTERVINIENTE_1_DIRECT_DEBIT]);
        formsValid.push(formsStored[INTERVINIENTE_2_DIRECT_DEBIT]);
      }

      if (this.intervinientes.length === 3) {
        formsValid.push(formsStored[INTERVINIENTE_1_DIRECT_DEBIT]);
        formsValid.push(formsStored[INTERVINIENTE_2_DIRECT_DEBIT]);
        formsValid.push(formsStored[INTERVINIENTE_3_DIRECT_DEBIT]);
      }

      if (this.intervinientes.length === 4) {
        formsValid.push(formsStored[INTERVINIENTE_1_DIRECT_DEBIT]);
        formsValid.push(formsStored[INTERVINIENTE_2_DIRECT_DEBIT]);
        formsValid.push(formsStored[INTERVINIENTE_3_DIRECT_DEBIT]);
        formsValid.push(formsStored[INTERVINIENTE_4_DIRECT_DEBIT]);
      }

      return formsValid.findIndex((form) => form?.status === 'INVALID') < 0;
    }
  }

  public tellChildClearTable() {
    this.changingValueClearTable.next(false);
  }

  public clearFields() {
    this.requestsStore.resetForms(FORM_AUTO);
    this.tellChildClearTable();
    // this.updateValueRef(null);
    this.clearTest();
  }

  openDialogPassword(type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '550px';
    let invalidFields: string[];

    invalidFields = this.fieldsRequired(type);
    console.log(invalidFields);

    if (invalidFields.length === 0) {
      let request_type: string;
      request_type = FORM_AUTO;
      this.requestsStore.numIntervinientes = this.intervinientes.length;

      let message;
      if (type !== 'save') {
        message = this.customValidatorsService.isAssuranceValid(request_type, this.requestsStore.listaFormulariosAutos);
      }

      if (message) {
        dialogConfig.data = { text: this.translate.instant(message), icon: 'icon-ic_warning' };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      } else {
        dialogConfig.data = {
          type: type,
          request_type: request_type,
          isAuto: true,
          request: this.request,
          operative: this.operative,
          mode: this.mode,
        };
        const passwordDialog = this.dialog.open(PaswordDialogComponent, dialogConfig);
        passwordDialog.afterClosed().subscribe((dataDialogPass: any) => {
          if (dataDialogPass?.password) {
            if (type === 'print') {
              this.requestsStore.printRequest(request_type, dataDialogPass, this.numOperation, dialogConfig);
            } else if (type === 'send') {
              if (
                this.customValidatorsService.isOwnerValid(
                  this.intervinientes.length,
                  this.requestsStore.listaFormulariosAutos
                )
              ) {
                if (
                  this.customValidatorsService.isOwnerMoreThanOneValid(
                    this.intervinientes.length,
                    this.requestsStore.listaFormulariosAutos
                  )
                ) {
                  if (
                    this.customValidatorsService.checkNoEmailNoPhone(
                      this.intervinientes.length,
                      this.requestsStore.listaFormulariosAutos
                    )
                  ) {
                    this.requestsStore.saveAndSend(
                      type,
                      request_type,
                      dataDialogPass,
                      this.numOperation,
                      this.hostStatus
                    );
                  } else {
                    //show dialog noemail
                    dialogConfig.data = {
                      title: this.translate.instant('dialog.noemail.title'),
                      text: this.translate.instant('dialog.noemail.signature.text'),
                      icon: 'icon-ic_warning',
                      buttonCancel: true,
                    };
                    const dialogNoEmail = this.dialog.open(ResponseDialogComponent, dialogConfig);
                    dialogNoEmail.afterClosed().subscribe((accept: boolean) => {
                      console.log('accept: ', accept);
                      if (accept) {
                        this.requestsStore.saveAndSend(
                          type,
                          request_type,
                          dataDialogPass,
                          this.numOperation,
                          this.hostStatus
                        );
                      }
                    });
                  }
                } else {
                  dialogConfig.data = {
                    text: this.translate.instant('request.error.holderAccountMoreThanOne'),
                    icon: 'icon-ic_warning',
                  };
                  this.dialog.open(ResponseDialogComponent, dialogConfig);
                }
              } else {
                dialogConfig.data = {
                  text: this.translate.instant('request.error.holderAccountOne'),
                  icon: 'icon-ic_warning',
                };
                this.dialog.open(ResponseDialogComponent, dialogConfig);
              }
            } else if (type === 'save') {
              this.requestsStore.saveAndSend(type, request_type, dataDialogPass, this.numOperation, this.hostStatus);
            } else if (type === 'save_rack') {
              //save rack and num registration car
              this.requestsStore.saveRackAutos(request_type, dataDialogPass, this.numOperation);
            }
          }
        });
      }
    } else {
      let text = invalidFields.join(' , ');
      dialogConfig.data = { text: this.translate.instant('dialog.fieldRequired') + text, icon: 'icon-ic_warning' };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    }
  }

  updateFinancing(event: CalculatorResponseDTO) {
    this.tariffs = event;
  }

  public updateCombosVendor(vendor: VendorComboDTO) {
    this.vendor = vendor;
    this.tellChildClearTable();
    this.requestsStore.listaFormulariosAutos[FINANCE].reset();
    this.isFirstStepCompleted = false;
  }

  public openCalculateFinance(data: CalculatorAutosDTO) {
    this.dataFinance = data;
    console.log(this.dataFinance);
  }

  public setExpiredMonth(month: string) {
    this.expirationMonth = month;
  }

  public addIntervinente(i: number) {
    this.intervinientes.push({ id: i, request: null });
  }

  public deleteInterviniente(i: Participant) {
    const participant = this.intervinientes.find((e) => e.id === i.id)?.id;
    if (participant >= 0) {
      const startDeleteFrom =
        participant === 1
          ? INTERVINIENTE_1_HOLDER_DATA
          : participant === 2
          ? INTERVINIENTE_2_HOLDER_DATA
          : participant === 3
          ? INTERVINIENTE_3_HOLDER_DATA
          : participant === 4
          ? INTERVINIENTE_4_HOLDER_DATA
          : undefined;
      if (startDeleteFrom) {
        this.requestsStore.listaFormulariosAutos.splice(startDeleteFrom, 4);
      }
    }
    this.intervinientes = this.intervinientes.filter((e) => e.id !== i.id);
    this.intervinientes.forEach((e) => (e.id = i.id < e.id ? e.id - 1 : e.id));

    this.updateDisabledSendButton();
    this.updateSteps();
  }

  public fieldsRequired(type: string): string[] {
    if (type === 'print') {
      return this.fieldsRequiredPrint();
    } else {
      return this.fieldsRequiredSave();
    }
  }

  public fieldsRequiredSave(): string[] {
    let invalidFields: string[] = [];
    this.requestsStore.listaFormulariosAutos.forEach((form, index) => {
      for (const name in form.controls) {
        if (form.controls[name].invalid) {
          switch (name) {
            case 'establishment':
              invalidFields.push(this.translate.instant('pointOfSale.establishment'));
              break;
            case 'vendor':
              invalidFields.push(this.translate.instant('pointOfSale.vendor'));
              break;
            case 'requestDate':
              invalidFields.push(this.translate.instant('pointOfSale.requestDate'));
              break;
            case 'nifNie':
              invalidFields.push(this.translate.instant('holderData.nifNie'));
              break;
            case 'nifNieExpiration':
              invalidFields.push(this.translate.instant('holderData.nifNieExpiration'));
              break;
            case 'name':
              invalidFields.push(this.translate.instant('holderData.name'));
              break;
            case 'surname1':
              invalidFields.push(this.translate.instant('holderData.surname1'));
              break;
            case 'surname2':
              invalidFields.push(this.translate.instant('holderData.surname2'));
              break;
            case 'commercialProduct':
              invalidFields.push(this.translate.instant('request.commercialProduct'));
              break;
          }
        }
      }
    });
    return invalidFields;
  }

  public fieldsRequiredPrint(): string[] {
    let invalidFields: string[] = [];
    this.requestsStore.listaFormulariosAutos.forEach((form, index) => {
      for (const name in form.controls) {
        if (form.controls[name].invalid) {
          switch (name) {
            case 'establishment':
              invalidFields.push(this.translate.instant('pointOfSale.establishment'));
              break;
            case 'vendor':
              invalidFields.push(this.translate.instant('pointOfSale.vendor'));
              break;
            case 'requestDate':
              invalidFields.push(this.translate.instant('pointOfSale.requestDate'));
              break;
            case 'nifNie':
              invalidFields.push(this.translate.instant('holderData.nifNie'));
              break;
            case 'nifNieExpiration':
              invalidFields.push(this.translate.instant('holderData.nifNieExpiration'));
              break;
            case 'name':
              invalidFields.push(this.translate.instant('holderData.name'));
              break;
            case 'surname1':
              invalidFields.push(this.translate.instant('holderData.surname1'));
              break;
            case 'surname2':
              invalidFields.push(this.translate.instant('holderData.surname2'));
              break;
            case 'birthDate':
              invalidFields.push(this.translate.instant('holderData.birthDate'));
              break;
            case 'commercialProduct':
              invalidFields.push(this.translate.instant('request.commercialProduct'));
              break;
            case 'lineProduct':
              invalidFields.push(this.translate.instant('request.lineProduct'));
              break;
            case 'product':
              invalidFields.push(this.translate.instant('request.product'));
              break;
            case 'priceProduct':
              invalidFields.push(this.translate.instant('requestDataAutos.priceVehicle'));
              break;
            case 'requestedAmount':
              invalidFields.push(this.translate.instant('request.requestedAmount'));
              break;
            case 'start':
              invalidFields.push(this.translate.instant('request.start'));
              break;
            case 'term':
              invalidFields.push(this.translate.instant('request.term'));
              break;
            case 'expireDate':
              invalidFields.push(this.translate.instant('request.expireDate'));
              break;
            case 'tariffs':
              invalidFields.push(this.translate.instant('request.tariffs'));
              break;
            case 'finance':
              invalidFields.push(this.translate.instant('requestFinance.title'));
              break;
            // campos obligatorios imprimir
            case 'requestLanguage':
              invalidFields.push(this.translate.instant('pointOfSale.requestLanguage'));
              break;
            case 'laboralSituation':
              invalidFields.push(this.translate.instant('socioeconimicData.laboralSituation'));
              break;
            case 'ownershipCombo':
              invalidFields.push(this.translate.instant('request.ownershipLabel'));
              break;
            case 'numberCreditAccount':
              invalidFields.push(this.translate.instant('request.bankAccount'));
              break;
          }
        }
      }
    });
    return invalidFields;
  }

  private clearTest(): void {
    this.requestsStore.numOperation = '';
    this.requestsStore.optionTest = false;
    this.requestsStore.optionTestAccept = '';
  }

  public changeContinueLoadingStatus(loadingState: any) {
    const formID = loadingState.formID;
    const value = loadingState.value;
    switch (formID) {
      case POINT_OF_SALE:
        this.isPointOfSaleLoaded = value;
        break;
      case REQUEST_DATA:
        this.isRequestDataLoaded = value;
        break;
      case FINANCE:
        this.isFinanceLoaded = value;
        break;
      case HOLDER_DATA:
        this.isHolderLoaded = value;
        break;
      case CONTACT_DATA:
        this.isContactLoaded = value;
        break;
      case SOCIOECONOMIC_DATA:
        this.isSocioeconomicLoaded = value;
        break;
      case DIRECT_DEBIT:
        this.isDirectDebitLoaded = value;
        break;
      case REQUEST_OBSERVATIONS:
        this.isObservationsLoaded = value;
        break;
      case PRESCRIBER_CONTACT_DATA:
        this.isPrescriberDataLoaded = value;
        break;
      default:
        console.error('No se ha encontrado el formulario');
    }
    this.triggerStopLoader();
  }

  private triggerStopLoader(): void {
    if (this.mode === REQUEST_MODE_NEW) {
      if (
        this.isPointOfSaleLoaded &&
        this.isRequestDataLoaded &&
        this.isFinanceLoaded &&
        this.isHolderLoaded &&
        this.isContactLoaded &&
        this.isSocioeconomicLoaded &&
        this.isDirectDebitLoaded &&
        this.isObservationsLoaded &&
        this.isPrescriberDataLoaded
      ) {
        this.loaderGenericService.stopSpinner();
      } else {
        this.loaderGenericService.showSpinner();
      }
    } else {
      if (
        this.isPointOfSaleLoaded &&
        this.isRequestDataLoaded &&
        this.isHolderLoaded &&
        this.isContactLoaded &&
        this.isSocioeconomicLoaded &&
        this.isDirectDebitLoaded &&
        this.isObservationsLoaded &&
        this.isPrescriberDataLoaded
      ) {
        this.isFinishedLoading.emit(true);
      } else {
        this.isFinishedLoading.emit(false);
      }
    }
  }

  private changeErrorStateGeneric(reference: number) {
    switch (reference) {
      case REQUEST_STEPPER_1:
        this.firstStepError = !this.isFirstStepCompleted;
        break;
      case REQUEST_STEPPER_2:
        this.secondStepError = !this.isSecondStepCompleted;
        break;
      case REQUEST_STEPPER_3:
        this.thirdStepError = !this.isThirdStepCompleted;
        break;
      default:
        console.error('changeErrorState: Reference not found');
    }
  }

  //This is new
  changeStepper(event: any, stepper: MatStepper) {
    stepper.steps.forEach((step, index) => {
      if (step.interacted) this.changeErrorStateGeneric(index);
    });
  }

  private changeErrorStateEditView(reference: number) {
    if (this.mode !== REQUEST_MODE_NEW) {
      this.changeErrorStateGeneric(reference);
    }
  }

  changeValueClearTable(change: boolean) {
    this.clearTable = change;
    if (change) {
      this.changingValueClearTable.next(true);
    } else {
      this.changingValueClearTable.next(false);
    }
  }
}
